import { useRef } from "react";
import styled, { css } from "styled-components";

import { useClickOutside } from "../../../../hooks/useClickOutside";
import { FlexRowCenter } from "../../Styles";
import VideoPlayerProps from "../VideoPlayer";

const VolumeDropDown = ({
  volume,
  setVolume,
  setIsVolumeShow,
  isViewOnly,
}: VideoPlayerProps.VolumeDropDownProps) => {
  const volumeRef = useRef<HTMLDivElement>(null);
  useClickOutside({ ref: volumeRef, setState: setIsVolumeShow });
  return (
    <VolumeContainer
      ref={volumeRef}
      $volume={100 - volume * 100}
      onClick={(e) => {
        e.stopPropagation();
      }}
      $isViewOnly={isViewOnly}
    >
      <CustomSlider
        type="range"
        min="0"
        max="1"
        step="0.1"
        value={volume}
        onChange={(e) => {
          e.stopPropagation();
          setVolume(Number(e.target.value));
        }}
        $volume={volume * 100}
      />
    </VolumeContainer>
  );
};

export default VolumeDropDown;

const VolumeContainer = styled(FlexRowCenter)<{
  $volume: number;
  $isViewOnly: boolean;
}>`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
  right: ${({ theme, $isViewOnly }) =>
    $isViewOnly
      ? -theme.spacing["spacing-1"].value
      : theme.spacing["spacing-15"].value}rem;
  height: 120px;
  padding: 10px 14px;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ $volume }) =>
    `linear-gradient(180deg, rgba(0, 0, 0, 0.7) ${$volume}%, #000 100%)`};
`;
const sliderThumbCss = css`
  width: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-full-round"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
`;
const CustomSlider = styled.input<{ $volume: number }>`
  margin: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  -webkit-appearance: none;
  writing-mode: sideways-lr;
  cursor: pointer;
  width: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-full-round"].value}rem;
  background: ${({ $volume, theme }) =>
    `linear-gradient(
    0deg,
    ${theme.Color.background.brand.default.value} 0%,
    ${theme.Color.background.brand.default.value} ${$volume}%,
    ${theme.Color.background["on-bold"]["default-active"].value} ${$volume}%,
    ${theme.Color.background["on-bold"]["default-active"].value} 100%
  )`};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${sliderThumbCss}
  }

  &::-moz-range-thumb {
    ${sliderThumbCss}
  }
`;
